var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "139px",
    viewBox: "0 0 140 139",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D0F2B676-C59A-4CFB-AD24-8DEE5901A704") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home-feed_storyline_start-to-sharge",
    transform: "translate(-32.000000, -447.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Creativity",
    transform: "translate(0.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "creativity",
    transform: "translate(8.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,113 L57,125.896597 C57,133.156158 62.7977224,139 70,139 C77.2022729,139 83,133.156158 83,125.896597 L83,113 L57,113 Z",
    id: "rect3299",
    fill: "#5332A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,6 C43.8179288,6 22.998875,25.1604488 23,50.9333007 C23.0563634,79.9172637 43.78736,81.5578599 43.78736,108.444498 C43.78736,114.846248 48.9229668,120 55.3021634,120 L83.6978444,120 C90.077041,120 95.2126435,114.846248 95.2126435,108.444498 C95.2126435,82.6622748 115.972952,80.1748157 116,50.9333007 C116.001132,25.1604496 95.1820747,6 69.5,6 L69.5,6 Z",
    id: "path3301",
    fill: "#805DDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1464925,40.6946579 L69.498873,52.3246372 L57.8535075,40.6946579 C55.5532272,38.3978613 51.9196289,38.4726764 49.6909323,40.6946579 C47.4363559,42.9450523 47.4363559,46.5944765 49.6909323,48.8448709 L63.7325459,62.856216 L63.7325459,120 L75.2674541,120 L75.2674541,62.8652198 L89.3090677,48.8448709 C91.5636441,46.5944765 91.5636441,42.9450523 89.3090677,40.6946579 C87.0576859,38.4466824 83.3348567,38.5128854 81.1464925,40.6946579 Z",
    id: "path3366",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#D5C5FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.255204687,51.9502458 C0.255204687,48.7318764 2.83654656,46.1409147 6.04296656,46.1409147 L11.8989622,46.1409147 C15.1053822,46.1409147 17.6867241,48.7318764 17.6867241,51.9502458 C17.6867241,55.1686152 15.1053822,57.759577 11.8989622,57.759577 L6.04296656,57.759577 C2.83654656,57.759577 0.255204687,55.1686152 0.255204687,51.9502458 Z",
    id: "rect3551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.518911,98.1873915 C11.2516294,95.9116639 11.2516294,92.2474893 13.518911,89.9717573 L17.6597251,85.8155151 C19.9270063,83.5397831 23.577575,83.5397831 25.8448562,85.8155151 C28.1121378,88.0912427 28.1121378,91.7554173 25.8448562,94.0311493 L21.7040421,98.1873915 C19.4367609,100.463124 15.7861922,100.463124 13.518911,98.1873915 Z",
    id: "path3580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.518911,1.96264869 C11.2516294,4.2383763 11.2516294,7.9025509 13.518911,10.1782829 L17.6597251,14.3345251 C19.9270063,16.6102571 23.577575,16.6102571 25.8448562,14.3345251 C28.1121378,12.0587975 28.1121378,8.3946229 25.8448562,6.1188909 L21.7040421,1.96264869 C19.4367609,-0.313083489 15.7861922,-0.313083489 13.518911,1.96264869 Z",
    id: "path3590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.161466,51.9502458 C139.161466,48.7318764 136.580124,46.1409147 133.373704,46.1409147 L127.517709,46.1409147 C124.311289,46.1409147 121.729947,48.7318764 121.729947,51.9502458 C121.729947,55.1686152 124.311289,57.759577 127.517709,57.759577 L133.373704,57.759577 C136.580124,57.759577 139.161466,55.1686152 139.161466,51.9502458 Z",
    id: "path3594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897761,98.1873915 C128.165039,95.9116639 128.165039,92.2474893 125.897761,89.9717573 L121.756946,85.8155151 C119.489663,83.5397831 115.839093,83.5397831 113.571815,85.8155151 C111.304532,88.0912427 111.304532,91.7554173 113.571815,94.0311493 L117.71263,98.1873915 C119.979908,100.463124 123.630478,100.463124 125.897761,98.1873915 Z",
    id: "path3596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897761,1.96264869 C128.165039,4.2383763 128.165039,7.9025509 125.897761,10.1782829 L121.756946,14.3345251 C119.489663,16.6102571 115.839093,16.6102571 113.571815,14.3345251 C111.304532,12.0587975 111.304532,8.3946229 113.571815,6.1188909 L117.71263,1.96264869 C119.979908,-0.313083489 123.630478,-0.313083489 125.897761,1.96264869 Z",
    id: "path3598"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.0105cba18f89a6c569a77c6a683cf95b.svg";
export { ForwardRef as ReactComponent };